// extracted by css-extract-rspack-plugin
export default {"card":"XpgNO","overlay":"Yui2y"};